import { t } from "../../../../../utils/i18n";
import React from "react";
import Head from "./Head";
import Body from "./Body";
import { Transaction } from "../Types";

interface Props {
  transactions: Transaction[];
  loading: boolean;
  cardType: string;
}

const Table: React.FC<Props> = ({ transactions, loading, cardType }) => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-md-12">
        <div className="card rounded-lg shadow-sm table-responsive">
          <table className="table table-responsive w-100 d-block d-md-table">
            <Head cardType={cardType} />
            {loading ? (
              <tbody>
                <tr>
                  <td colSpan={8} className="text-center">
                    {t("cards.common.loading")}
                  </td>
                </tr>
              </tbody>
            ) : (
              <Body transactions={transactions} cardType={cardType} />
            )}
          </table>
        </div>
      </div>
    </div>
  </div>
);

export default Table;
